import {
  BOWLS,
  DRINKS,
  FULL_SIZE,
  HALF_SIZE,
  LARGE_SIZE,
  NO_TIME_SLOTS_PRESENT,
  REGULAR_SIZE,
  SALADS,
  SANDWICH_TRAY,
  SMALL_SIZE,
  SOUP_TRAY,
} from '../constants';

export const capitalizeFirstLetter = (value) => {
  return value.charAt(0)?.toUpperCase() + value.slice(1);
};
export const isSizeEqual = (item, reward) => {
  return (
    item.item_size?.toLowerCase() == reward.redirect_item_size?.toLowerCase()
  );
};
export const isCartEmpty = (Cart) =>
  Cart.cart.itemTree && Object.keys(Cart.cart.itemTree).length == 0;
export const getExpiry_year = (values) => {
  if (Number(values.card.expiration.split('/')[1]) < 100) {
    return Number(
      new Date().getFullYear().toString().substring(0, 2) +
        values.card.expiration.split('/')[1],
    );
  } else {
    return values.card.expiration.split('/')[1];
  }
};
export const formatDate = (date) => {
  const currentDate = new Date();
  const dateSplit = date ? date.split('-') : ['2023', '01', '01'];
  const selectedDate = new Date(dateSplit[0], dateSplit[1] - 1, dateSplit[2]);
  let updateDateFormat = '';
  if (
    currentDate.getDate() == selectedDate.getDate() &&
    currentDate.getDay() == selectedDate.getDay()
  ) {
    updateDateFormat =
      'Today, ' +
      selectedDate.toLocaleDateString('en-US', {
        weekday: 'long',
        // year: "numeric",
        month: 'short',
        day: 'numeric',
      });
  } else {
    updateDateFormat = selectedDate.toLocaleDateString('en-US', {
      weekday: 'long',
      // year: "numeric",
      month: 'short',
      day: 'numeric',
    });
  }
  return updateDateFormat;
};
export const formatTime = (time: string, orderDetails) => {
  if (orderDetails?.time == '' || orderDetails?.time == NO_TIME_SLOTS_PRESENT) {
    return NO_TIME_SLOTS_PRESENT;
  }
  if (!orderDetails?.time?.includes('ASAP')) {
    const hoursMinsSec = orderDetails?.time?.split(':');
    time = formatAMPM(hoursMinsSec[0], hoursMinsSec[1]);
  } else {
    time = orderDetails?.time;
  }
  return time;
};
export const formatAMPM = (hours, mins) => {
  const ampm = hours >= 12 ? 'pm' : 'am';
  hours %= 12;
  hours = hours || 12;
  mins = mins < 10 ? `${mins}` : mins;
  hours = hours < 10 ? `0${hours}` : hours;
  const formatedTime = `${hours}:${mins} ${ampm}`;

  return formatedTime;
};

export const scrollOnSize = (divRef, offset) => {
  setTimeout(() => {
    const yOffset = offset;
    const ScrollYCordinates =
      divRef?.current?.getBoundingClientRect().top +
      window.pageYOffset +
      yOffset;
    window.scrollTo({ top: ScrollYCordinates, behavior: 'smooth' });
  }, 250);
};
export const getSizeName = (categoryName: string) => {
  if (
    categoryName?.toLowerCase() === SANDWICH_TRAY ||
    categoryName?.toLowerCase() === SOUP_TRAY ||
    categoryName?.toLowerCase() === DRINKS
  )
    return LARGE_SIZE;
  else return FULL_SIZE;
};

export const getSizeNameInCaseOfHalf = (categoryName: string, size: string) => {
  if (categoryName?.toLowerCase() === DRINKS) return REGULAR_SIZE.upper_case;
  if (
    categoryName?.toLowerCase() === SANDWICH_TRAY ||
    categoryName?.toLowerCase() === SOUP_TRAY
  )
    return SMALL_SIZE.upper_case;
  else return size;
};

export const itemSizeForMobile = (
  sizeTextFor: 'HALF' | 'FULL',
  categoryName: string,
) => {
  switch (sizeTextFor) {
    case HALF_SIZE.upper_case:
      return categoryName?.toLowerCase() === DRINKS
        ? REGULAR_SIZE.title_case
        : HALF_SIZE.title_case;
    case FULL_SIZE.upper_case:
      return getSizeName(categoryName).title_case;
    default:
      break;
  }
};

export const itemSizeForDesktop = (
  sizeTextFor: 'HALF' | 'FULL',
  categoryName: string,
) => {
  switch (sizeTextFor) {
    case HALF_SIZE.upper_case:
      return categoryName?.toLowerCase() === DRINKS
        ? REGULAR_SIZE.upper_case
        : HALF_SIZE.upper_case;
    case FULL_SIZE.upper_case:
      return getSizeName(categoryName).upper_case;
    default:
      break;
  }
};

export const isZeroOnStart = (value) => {
  const valueArray = value && value?.split('');
  return valueArray?.length > 0 && valueArray[0] <= 0;
};

export const delayer = (func, time = 50) => {
  let isRun = false;
  return () => {
    if (isRun === false) {
      func();
      isRun = true;
      setTimeout(() => {
        isRun = false;
      }, time);
    }
  };
};
export const toTitleCase = (phrase) => {
  return phrase
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const formatAMPMWithPoint = (hours, mins) => {
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours %= 12;
  hours = hours || 12;
  mins = mins < 10 ? `${mins}` : mins;
  hours = hours < 10 ? `0${hours}` : hours;
  const formatedTime = `${hours}.${mins || '00'} ${ampm}`;

  return formatedTime;
};
export const getFormattedTime = (time: string) => {
  let updatedTime = '';
  const hoursMinsSec = time?.split(':');
  updatedTime = formatAMPMWithPoint(hoursMinsSec?.[0], hoursMinsSec?.[1]);

  return updatedTime;
};

export const isValidDateInput = (value: string) => {
  if (value?.length > 0) {
    const today = new Date();
    const currentYear = today.getFullYear();
    const [monthStr, dayStr, yearStr] = value.split('/');

    const month = parseInt(monthStr, 10);
    const day = parseInt(dayStr, 10);
    const year = parseInt(yearStr, 10);

    const isMonthValid = month >= 1 && month <= 12;
    const isDayValid = day >= 1 && day <= new Date(year, month, 0).getDate();
    const isYearValid = year >= currentYear - 149 && year <= currentYear - 13;

    return isMonthValid && isDayValid && isYearValid;
  }
  return true;
};

export const calculateAge = (value: string): number | null => {
  if (!value) return null;
  const [month, day, year] = value.split('/').map(Number);
  if (!month || !day || !year) return null;

  const birthDate = new Date(year, month - 1, day);
  const today = new Date();

  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  const dayDiff = today.getDate() - birthDate.getDate();

  if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
    age--;
  }

  return age;
};

export const hasMinAge = (value: string, minAge: number) => {
  const age = calculateAge(value);
  return age === null || age >= minAge;
};

export const hasMaxAge = (value: string, maxAge: number) => {
  const age = calculateAge(value);
  return age === null || age <= maxAge;
};

export function countDigits(str) {
  return (str.match(/\d/g) || []).length;
}

function getMaxDay(month) {
  if ([4, 6, 9, 11].includes(month)) return 30;
  if (month === 2) return 29;
  return 31;
}

function isLeapYear(year) {
  return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

function autoCorrectMonth(mm) {
  let monthNum = parseInt(mm, 10);
  if (monthNum >= 2 && monthNum <= 9 && mm[0] !== '0') {
    return '0' + monthNum;
  }
  if (monthNum > 12) {
    return `${Math.floor(monthNum / 10)}`;
  }
  return mm;
}

function autoCorrectDay(mm, dd) {
  const monthNum = parseInt(mm, 10);
  const maxDay = getMaxDay(monthNum);

  if (dd.length === 1) {
    const firstDigit = parseInt(dd[0], 10);
    const maxFirstDigit = Math.floor(maxDay / 10);
    if (firstDigit > maxFirstDigit) {
      return '0' + firstDigit;
    }
  }

  if (dd.length === 2) {
    const dayNum = parseInt(dd, 10);
    if (dayNum > maxDay) {
      return `${Math.floor(dayNum / 10)}`;
    }
  }

  return dd;
}

export function handleBirthdayChange(e, params) {
  const {
    isBirthdayFieldTouched,
    setIsBirthdayFieldTouched,
    setFieldValue,
    birthdayRef,
  } = params;
  if (!isBirthdayFieldTouched) setIsBirthdayFieldTouched(true);

  const input = e.target;
  const originalCaret = input.selectionStart;
  let forceCursorToCurrentStep = false;

  let rawVal = input.value;
  const numeric = rawVal.replace(/[^0-9]/g, '');

  let mm = numeric.slice(0, 2);
  let dd = numeric.slice(2, 4);
  let yyyy = numeric.slice(4, 8);

  const correctedMonth = autoCorrectMonth(mm);
  if (correctedMonth !== mm) {
    mm = correctedMonth;
    forceCursorToCurrentStep = true;
  }

  dd = autoCorrectDay(mm, dd);

  if (mm === '02' && dd === '29' && yyyy.length === 4) {
    const yearNum = parseInt(yyyy, 10);
    if (!isLeapYear(yearNum)) {
      dd = '28';
    }
  }

  const padded = `${mm.padEnd(2, '_')}/${dd.padEnd(2, '_')}/${yyyy.padEnd(
    4,
    '_',
  )}`;
  setFieldValue('birthday', padded);

  setTimeout(() => {
    if (birthdayRef.current && originalCaret != null) {
      const lengthOfDigits = countDigits(padded);

      let newPos = lengthOfDigits;
      if (lengthOfDigits > 1 && lengthOfDigits < 4) {
        newPos += 1;
        newPos = Math.min(newPos, padded.length);
        birthdayRef.current.setSelectionRange(newPos, newPos);
      }
      if (lengthOfDigits === 4) {
        newPos += 2;
        newPos = Math.min(newPos, padded.length);
        birthdayRef.current.setSelectionRange(newPos, newPos);
      }
      if (forceCursorToCurrentStep) {
        newPos = Math.min(newPos, padded.length);
        birthdayRef.current.setSelectionRange(newPos, newPos);
        forceCursorToCurrentStep = false;
      }
    }
  }, 0);
}
